export default __webpack_public_path__ + "static/media/CombinedImage.07297f91.png";